define('gameday-index-footer/GDIndexFooterComponent',['require','exports','module','jquery','gameday-index-component-base/GDIndexComponentBase','message-service/message-service','gameday-index-enums/enums/events/LoadEvents','app-console/app-console','responsive-gameday-footer/responsive-gameday-footer'],function(require, exports, module) {
	// require imports
	var $ = require("jquery"),
		BaseClass = require("gameday-index-component-base/GDIndexComponentBase"),
		dispatcher = require("message-service/message-service"),
		LoadEvts = require("gameday-index-enums/enums/events/LoadEvents"),
		logg = require("app-console/app-console"),
		Footer = require('responsive-gameday-footer/responsive-gameday-footer');

	// instance variables
	var Superclass,
		appConfig = {};

	function GDFooter(compID, divID) {
	
		this.componentID = compID;
		this.targetDiv = divID;		
		this.init();
		
	}


	BaseClass.spawn(GDFooter).define({
		init: function() {
			logg.log(this.targetDiv);

			var footerInstance = new Footer(this.targetDiv);
			footerInstance.init(appConfig);

			this.buildAppSettings();
			this.initialized = true;

			dispatcher.publish(LoadEvts.componentReady, this.componentID);
		},

		buildAppSettings: function() {
			// expand / extend the appConfig obj from above
			// iterate through config objects to construct the prpper params
		}
	});

	Superclass = GDFooter.superclass;
	return GDFooter;
});

